(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ante-image"] && !Shopify.designMode) return;
  try {
    function destroyVideo(wrapper) {
    const video = wrapper?.querySelector("video")
    if (!video) return

    video.pause()
    video.removeAttribute("src")
    video.load()

    for (const source of video.querySelectorAll("source")) {
      source.remove()
    }

    video.srcObject = null
    wrapper.remove()
  }

  function removeInlineVideo(image) {
    destroyVideo(image._inlineVideo)
    image._inlineVideo = null
    image._inlineActive = false
    image.classList.remove("video-inlined")
  }

  function removeHoverVideo(image) {
    destroyVideo(image._video)
    image._video = null
    image._video_removed = true
    image.classList.remove("video-previewing")
  }

  document.addEventListener("mouseenter", e => {
    const image = e.target.closest?.(".ante-image")
    if (!image || image._inlineActive || image._video) return

    const modal = image.dataset.modal ?? image.dataset.video
    if (!modal) return

    image._video_removed = false
    image._video = document.createElement("div")
    image._video.classList.add("ante-image-video-preview")
    image._video.innerHTML = modal

    const video = image._video.querySelector("video")
    video.removeAttribute("controls")
    video.muted = true

    function onReady() {
      if (!image._video_removed && !image._inlineActive) {
        image.append(image._video)
        image.classList.add("video-previewing")
        video.play()
      }
    }

    if (video.readyState >= 2) onReady()
    else video.addEventListener("loadeddata", onReady, { once: true })
  }, true)

  document.addEventListener("mouseleave", e => {
    const image = e.target.closest?.(".ante-image")
    if (!image || image._inlineActive) return
    removeHoverVideo(image)
  }, true)

  document.addEventListener("click", e => {
    const image = e.target.closest?.(".ante-image")

    for (const el of document.querySelectorAll(".ante-image.video-inlined")) {
      if (el !== image) removeInlineVideo(el)
    }

    if (image && image.dataset.video) {
      if (image._inlineActive) return

      let resumeTime = 0
      let resume = false

      if (image._video) {
        const previewVideo = image._video.querySelector("video")
        if (previewVideo && Number.isFinite(previewVideo.currentTime) && previewVideo.currentTime > 0) {
          resumeTime = previewVideo.currentTime
          resume = true
        }
      }

      removeHoverVideo(image)

      image._inlineActive = true
      image._inlineVideo = document.createElement("div")
      image._inlineVideo.classList.add("ante-image-video-inline")
      image._inlineVideo.innerHTML = image.dataset.video

      const realVideo = image._inlineVideo.querySelector("video")
      realVideo.setAttribute("controls", "")

      if (resume) {
        function applyResume() {
          const duration = Number.isFinite(realVideo.duration) ? realVideo.duration : 0
          realVideo.currentTime = duration > 0 ? Math.min(resumeTime, Math.max(0, duration - 0.05)) : resumeTime
        }
        if (realVideo.readyState >= 1) applyResume()
        else realVideo.addEventListener("loadedmetadata", applyResume, { once: true })
      }

      image.append(image._inlineVideo)
      image.classList.add("video-inlined")
      realVideo.play()
    }
  })
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ante-import-main"] && !Shopify.designMode) return;
  try {
    // Smooth scrolling

  window.getStickyTop = () => {
    const el = document.createElement("div")
    el.style.position = "fixed"
    el.style.top = "var(--sticky-top)"
    el.style.left = "0"
    el.style.width = "0"
    el.style.height = "0"
    el.style.pointerEvents = "none"
    el.style.visibility = "hidden"
    document.body.appendChild(el)
    const value = el.getBoundingClientRect().top
    el.remove()
    return value
  }

  function getElementTop(el) {
    let offset = 0
    if (el.classList.contains("ante-section")) {
      const child = el.firstElementChild
      if (child) {
        offset = parseFloat(getComputedStyle(child).paddingTop) || 0
      }
    } else if (el.classList.contains("ante-container")) {
      offset = parseFloat(getComputedStyle(el).paddingTop) || 0
    } else {
      if (Math.round(el.clientWidth) === document.documentElement.clientWidth) {
        offset = parseFloat(getComputedStyle(el).paddingTop) || 0
      }
    }
    return el.getBoundingClientRect().top + window.scrollY - getStickyTop() + offset
  }

  window.smoothScroll = (element, args = {}) => {
    let el = element

    while (el && getComputedStyle(el).display === "none") {
      el = el.nextElementSibling
    }

    if (!el) el = element

    if (args.lazy) {
      const rect = el.getBoundingClientRect()
      if (rect.top >= 0 && rect.top <= window.innerHeight) return
    }

    let attempts = 0
    let lastTop = null

    function scroll() {
      const top = getElementTop(el)
      if (lastTop !== null && Math.abs(top - lastTop) < 2) return
      lastTop = top

      window.scrollTo({ top, behavior: "smooth" })
      attempts++
      if (attempts < 4) setTimeout(scroll, 500)
    }

    scroll()
  }

  document.body.addEventListener("click", e => {
    const link = e.target.closest("a[href^='#']")
    if (!link) return

    const id = link.getAttribute("href").slice(1)
    if (!id) return

    const modalMatches = Array.from(document.querySelectorAll(`#modal-content-${id}`))
    if (modalMatches.length) {
      const modalContent = modalMatches[modalMatches.length - 1]
      e.preventDefault()
      showAnchorModal(JSON.parse(modalContent.textContent))
      return
    }

    const target = document.querySelector(id.startsWith(".") || id.startsWith("[") ? id : `#${id}`)
    if (!target) return

    e.preventDefault()
    smoothScroll(target)

    history.replaceState(null, "", window.location.pathname + window.location.search)

    if ("click" in link.dataset) {
      if (target.previousElementSibling?.type == "checkbox" && target.previousElementSibling?.checked) {
        return
      }
      target.click()
    }
  })

  // Newsletter

  if (location.search.includes("customer_posted=true") && location.hash === "#newsletter") {
    openModal("Signed up!", "Thanks for subscribing to our newsletter!")
    const url = new URL(location)
    url.searchParams.delete("customer_posted")
    history.replaceState(null, "", url.pathname + url.search)
  }

  // Add to cart

  async function fetchCart() {
    const cartReq = await fetch("/cart.js")
    if (cartReq.ok) {
      return cartReq.json().then(e => e.items)
    }
    if (cartReq.headers.get("Content-Type").startsWith("text/html")) {
      openModal("Failed to load cart", `<div>Please verify you are human. After verifying, close this popup and try again.</div><iframe src="/cart.js" style="width: 100%; height: 294px; margin-top: var(--spacing-x-small); border: none;">`)
    } else {
      openModal("Failed to load cart", `Cart request responded with status: ${cartReq.status}`)
    }
  }
  window.fetchCart = fetchCart

  async function addToCart(items) {
    const cart = await fetchCart()
    if (!cart) return

    const newIds = new Set(items.map(i => parseInt(i.id)))
    const overlapping = cart.filter(i => newIds.has(i.variant_id))

    const changes = []
    const updates = [{}]
    let replaceOverlapping

    if (overlapping.length) {
      const displayMap = {}

      for (const item of overlapping) {
        if (!displayMap[item.variant_id]) {
          displayMap[item.variant_id] = {
            product_title: item.product_title,
            variant_title: item.variant_title,
            quantity: 0
          }
        }
        displayMap[item.variant_id].quantity += item.quantity
      }

      const list = Object.values(displayMap).map(i => {
        const title = `${i.product_title}${i.variant_title ? ` (${i.variant_title})` : ""}`
        return `<div class="add-to-cart-modal-cart-item"><h6>${i.quantity > 1 ? `${title}</h6> <span class="body-captiion">x${i.quantity}<span>` : title + "</h6>"}</div>`
      }).join("")

      await openModal("", `
        <svg width="80" height="80" viewBox="0 0 80 80" fill="none">
          <path d="M78.338 59.992L50.078 8.043c-4.54-7.644-15.609-7.654-20.155 0L1.664 59.992c-4.642 7.811.978 17.702 10.075 17.702H68.26c9.09 0 14.719-9.883 10.078-17.702zM40 68.319c-2.584 0-4.687-2.103-4.687-4.687s2.103-4.687 4.688-4.687 4.688 2.103 4.688 4.688-2.103 4.688-4.687 4.688zm4.688-18.75c0 2.584-2.103 4.688-4.687 4.688s-4.687-2.103-4.687-4.687V26.131c0-2.584 2.103-4.687 4.688-4.687s4.688 2.103 4.688 4.688v23.438z" fill="url(#add-to-cart-warning-gradient)"/>
          <defs>
            <linearGradient id="add-to-cart-warning-gradient" x1="80" y1="71.667" x2="5.417" y2="29.583" gradientUnits="userSpaceOnUse">
              <stop stop-color="#e58a22"/>
              <stop offset="1" stop-color="#fbb03a"/>
            </linearGradient>
          </defs>
        </svg>
        <div class="add-to-cart-modal-contents">
          <h4>You already have ${Object.values(displayMap).length === 1 ? "this product" : "these products"} in your basket:</h4>
          <div class="add-to-cart-modal-cart-items">${list}</div>
          <div>If you are buying for multiple people, you can keep everything as is. Otherwise, you can revert to one unit per product.</div>
        </div>
        <div class="add-to-cart-modal-buttons">
          <button class="ante-button small keep">I Want Multiple</button>
          <button class="ante-button secondary small replace">Don't Add Extra</button>
        </div>
      `, "add-to-cart-modal", modal => {
        modal.querySelector(".keep").addEventListener("click", modal.close)
        modal.querySelector(".replace").addEventListener("click", () => {
          replaceOverlapping = true
          modal.close()
        })
      })
    }

    if (replaceOverlapping) {
      const counts = {}

      for (const item of overlapping) {
        const id = item.variant_id
        counts[id] = (counts[id] || 0) + 1
      }

      const passes = Math.max(...Object.values(counts))

      for (let i = 0; i < passes; i++) {
        updates[i] ??= {}
        for (const variantId in counts) {
          updates[i][variantId] = 0
        }
      }
    }

    const otherDuplicatesMap = {}
    for (const item of cart) {
      if (newIds.has(item.variant_id)) continue
      if (!otherDuplicatesMap[item.variant_id]) {
        otherDuplicatesMap[item.variant_id] = {
          product_title: item.product_title,
          variant_title: item.variant_title,
          quantity: 0
        }
      }
      otherDuplicatesMap[item.variant_id].quantity += item.quantity
    }

    const otherDuplicates = Object.entries(otherDuplicatesMap)
      .filter(([, v]) => v.quantity > 1)

    if (otherDuplicates.length) {
      const list = otherDuplicates.map(([, i]) => {
        const title = `${i.product_title}${i.variant_title ? ` (${i.variant_title})` : ""}`
        return `<div class="add-to-cart-modal-cart-item"><h6>${title}</h6> <span class="body-captiion">x${i.quantity}<span></div>`
      }).join("")

      await openModal("", `
        <svg width="80" height="80" viewBox="0 0 80 80" fill="none">
          <path d="M78.338 59.992L50.078 8.043c-4.54-7.644-15.609-7.654-20.155 0L1.664 59.992c-4.642 7.811.978 17.702 10.075 17.702H68.26c9.09 0 14.719-9.883 10.078-17.702zM40 68.319c-2.584 0-4.687-2.103-4.687-4.687s2.103-4.687 4.688-4.687 4.688 2.103 4.688 4.688-2.103 4.688-4.687 4.688zm4.688-18.75c0 2.584-2.103 4.688-4.687 4.688s-4.687-2.103-4.687-4.687V26.131c0-2.584 2.103-4.687 4.688-4.687s4.688 2.103 4.688 4.688v23.438z" fill="url(#add-to-cart-warning-gradient)"/>
          <defs>
            <linearGradient id="add-to-cart-warning-gradient" x1="80" y1="71.667" x2="5.417" y2="29.583" gradientUnits="userSpaceOnUse">
              <stop stop-color="#e58a22"/>
              <stop offset="1" stop-color="#fbb03a"/>
            </linearGradient>
          </defs>
        </svg>
        <div class="add-to-cart-modal-contents">
          <h4>${otherDuplicates.length === 1 ? `You have ${overlapping.length ? "another" : "a"} duplicated product in your basket:` : `You have ${overlapping.length ? "other" : "some"} duplicated products in your basket:`}</h4>
          <div class="add-to-cart-modal-cart-items">${list}</div>
          <div>${otherDuplicates.length === 1 ? `Would you like us to clean this up and keep only one?` : `Would you like us to clean these up and keep one of each?`}</div>
        </div>
        <div class="add-to-cart-modal-buttons">
          <button class="ante-button small keep">Keep Multiple</button>
          <button class="ante-button secondary small replace">Keep Only One</button>
        </div>
      `, "add-to-cart-modal", modal => {
        modal.querySelector(".keep").addEventListener("click", modal.close)
        modal.querySelector(".replace").addEventListener("click", () => {
          const variantIds = new Set(otherDuplicates.map(([id]) => Number(id)))
          const linesByVariant = {}
          cart.forEach((item, index) => {
            if (!variantIds.has(item.variant_id)) return
            const line = index + 1
            linesByVariant[item.variant_id] ??= []
            linesByVariant[item.variant_id].push(line)
          })
          for (const variantId in linesByVariant) {
            const lines = linesByVariant[variantId]
            changes.push({ line: lines[0], quantity: 1 })
            for (let i = 1; i < lines.length; i++) {
              changes.push({ line: lines[i], quantity: 0 })
            }
          }
          modal.close()
        })
      })
    }

    changes.reverse()
    for (const change of changes) {
      await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(change)
      })
    }

    for (const update of updates) {
      if (Object.keys(update).length) {
        await fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ updates: update })
        })
      }
    }

    items.reverse()

    return await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items })
    })
  }
  window.addToCart = addToCart
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ante-import-marquee"] && !Shopify.designMode) return;
  try {
    function runMarqueeScripts(root) {
    const scripts = root.querySelectorAll("script")
    for (const oldScript of scripts) {
      const s = document.createElement("script")

      for (const { name, value } of Array.from(oldScript.attributes)) {
        s.setAttribute(name, value)
      }

      s.textContent = oldScript.textContent

      oldScript.replaceWith(s)
    }
  }

  function initMarquees() {
    const marquees = document.querySelectorAll(".marquee:not(.initialised)")
    for (const marquee of marquees) {
      const div = document.createElement("div")
      div.className = "marquee-sub"
      div.append(...marquee.children)
      marquee.append(div)

      const measure = div.cloneNode(true)
      measure.classList.add("marquee-measure")
      marquee.append(measure)

      const pxPerSec = marquee.dataset.speed ? parseFloat(marquee.dataset.speed) : 128
      let lastWidth = marquee.clientWidth

      function adjust() {
        const base = marquee.querySelector(".marquee-sub")
        const measureWidth = measure.clientWidth
        const needClones = Math.ceil(marquee.clientWidth / measureWidth)

        const clones = marquee.querySelectorAll(".marquee-sub.clone")
        const current = clones.length

        if (current > needClones) {
          for (let i = needClones; i < current; i++) clones[i].remove()
        } else if (current < needClones) {
          for (let i = current; i < needClones; i++) {
            const clone = base.cloneNode(true)
            clone.classList.add("clone")
            marquee.insertBefore(clone, measure)
            runMarqueeScripts(clone)
          }
        }

        const duration = measureWidth / pxPerSec
        marquee.querySelectorAll(".marquee-sub").forEach(sub => {
          sub.style.animation = "none"
          void sub.offsetWidth
          sub.style.animation = `marquee ${duration}s linear infinite`
        })

        if (!("infinite" in marquee.dataset)) {
          marquee.classList.toggle("scrolling", measureWidth > marquee.clientWidth)
        }

        lastWidth = marquee.clientWidth
      }

      setTimeout(adjust, 0)
      window.addEventListener("resize", () => {
        if (marquee.clientWidth !== lastWidth) adjust()
      })

      marquee.classList.add("initialised")

      if ("infinite" in marquee.dataset) marquee.classList.add("scrolling")

      if ("pausable" in marquee.dataset) {
        let paused = false
        const pause = () => marquee.classList.add("paused")
        const resume = () => marquee.classList.remove("paused")

        marquee.addEventListener("mouseenter", pause)
        marquee.addEventListener("mouseleave", () => {
          paused = false
          resume()
        })

        marquee.addEventListener("touchstart", () => {
          paused = !paused
          if (paused) pause()
          else resume()
        })
      }

      const observer = new IntersectionObserver(entries => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll("img[loading='lazy']").forEach(img => {
              img.loading = "eager"
            })
            observer.unobserve(entry.target)
          }
        }
      })
      observer.observe(marquee)
    }
  }

  addEventListener("DOMContentLoaded", () => {
    initMarquees()

    document.addEventListener("shopify:section:load", () => {
      initMarquees()
    })
  })
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ante-import-modals"] && !Shopify.designMode) return;
  try {
    const modals = document.createElement("div")
  modals.id = "modals"
  document.body.append(modals)

  function makeModal(title, content, id, args = {}) {
    const container = document.createElement("div")
    if (id) {
      container.id = id
    }
    container.classList.add("modal-container")
    if (args.type) {
      container.classList.add(`modal-type-${args.type}`)
    }
    if (args.transitionDuration) {
      container.style.setProperty("--modal-transition-duration", args.transitionDuration + "ms")
    }
    container.setAttribute("tabindex", "-1")
    container.innerHTML = `
      <div class="modal-element">
        <div class="modal-title-row">
          <div class="modal-title">${title ?? "Modal"}</div>
          <button class="modal-close">
            <svg width="28" height="28" viewBox="0 0 24 24"><path d="M13.46,12L19,17.54V19H17.54L12,13.46L6.46,19H5V17.54L10.54,12L5,6.46V5H6.46L12,10.54L17.54,5H19V6.46L13.46,12Z" /></svg>
          </button>
        </div>
        <div class="modal-contents ante-section richtext"></div>
      </div>
    `
    const contents = container.querySelector(".modal-contents")
    if (typeof content === "string") {
      contents.innerHTML = content
    } else {
      contents.append(...content.map(node => node.cloneNode(true)))
    }
    return container
  }

  function handleModal(modal, close, func) {
    modal.querySelector(".modal-title-row .modal-close").addEventListener("click", close)
    let down
    modal.addEventListener("mousedown", e => down = e.target)
    modal.addEventListener("mouseup", e => {
      if (down === e.target && e.target.classList.contains("modal-container")) {
        close()
      }
    })
    modal.addEventListener("keydown", e => {
      if (e.key === "Escape") {
        close()
      } else if (e.key === "Tab") {
        const focusable = modal.querySelectorAll(
          'a[href], button, input, textarea, select, [tabindex]:not([tabindex="-1"])'
        )
        if (!focusable.length) return
        const first = focusable[0]
        const last = focusable[focusable.length - 1]
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault()
          last.focus()
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault()
          first.focus()
        }
      }
    })
    modals.append(modal)
    if (func) {
      modal.modalElement = modal.querySelector(".modal-element")
      modal.modalElement.close = close
      func(modal.modalElement)
    }
  }

  window.openModal = (title, content, id, func, args = {}) => {
    return new Promise(fulfil => {
      const modal = makeModal(title, content, id, args)
      modal.classList.add("opening")
      function close() {
        if (modal.modalElement?.locked) return
        modal.classList.remove("open")
        modal.classList.add("closing")
        setTimeout(() => {
          modal.remove()
          const all = modals.querySelectorAll(".modal-container")
          if (all.length) {
            all[all.length - 1].focus()
          }
          fulfil()
        }, args.transitionDuration ?? 150)
      }
      handleModal(modal, close, func)
      setTimeout(() => {
        modal.classList.remove("opening")
        modal.classList.add("open")
        const focusable = modal.querySelectorAll(
          'a[href], button, input, textarea, select, [tabindex]:not([tabindex="-1"])'
        )
        if (focusable.length > 1) {
          focusable[1].focus()
        } else {
          modal.focus()
        }
      }, 0)
    })
  }

  document.addEventListener("click", e => {
    const el = e.target.closest("[data-modal], .modal")
    if (!el) return

    if (el.hasAttribute("data-modal")) {
      openModal(
        el.dataset.modalTitle,
        el.dataset.modal,
        el.dataset.modalId,
        null,
        el.dataset.modalType
      )
      return
    }

    const modals = document.querySelectorAll(".modal")
    for (const modal of modals) {
      if (!modal.dataset.trigger) continue
      if (e.target.closest("." + modal.dataset.trigger)) {
        if (!modal._modalData) {
          modal._modalData = {
            title: modal.dataset.title,
            content: [...modal.children],
            id: modal.dataset.modalId ?? modal.dataset.trigger + "-modal",
            type: modal.dataset.modalType
          }
        }

        const d = modal._modalData
        openModal(d.title, d.content, d.id, null, d.type)
        return
      }
    }
  })

  function showAnchorModal(data) {
    history.replaceState(null, "", location.pathname + location.search)
    let style = "<style>"
    if (data.width > 0) {
      style += `.modal-contents { width: clamp(var(--modal-min-width), ${data.width}px, var(--modal-max-width)); }\n`
    }
    let content = ""
    const id = data.contentType === "video" ? "video-modal" : "modal-" + Math.random().toString(16).replace("0.", "")
    if (data.contentType === "with_image") {
      content += `
        <div class="modal-with-image-top">
          <div class="richtext">${data.content.imageContent}</div>
          ${data.content.image ? `<img src="${data.content.image}">` : ""}
        </div>
        <div class="richtext">${data.content.secondaryContent}</div>
      `
      style += `
        .modal-with-image-top {
          display: flex;
          flex-direction: row;
          gap: var(--spacing-medium);
          margin-bottom: var(--spacing-small);
          align-items: center;
        }

        .modal-with-image-top:first-child {
          flex: 1;
          align-self: flex-start;
        }

        .modal-with-image-top img {
          max-width: min(100%, ${data.content.imageWidth}px);
        }

        @media (max-width: 600px) {
          .modal-with-image-top {
            flex-direction: column;
          }
        }
      `
    } else if (data.contentType === "iframe") {
      content += `<iframe src="${data.content.iframeURL}"></iframe>`
      style += `
        #${id} .modal-contents {
          padding: 0;
        }
        
        #${id} iframe {
          display: block;
          border: none;
          width: 100%;
          height: var(--modal-max-height);
        }
      `
    } else if (data.contentType === "images") {
      content += data.content.images.map(e => `<img src="${e}">`).join("")
    } else if (data.contentType === "video") {
      content += `<video controls playsinline src="${data.content.video}"${data.content.autoplay ? " autoplay" : ""}></video>`
    } else {
      content += data.content.content
    }
    style += "</style>"
    if (style !== "<style></style>") {
      content += style
    }
    openModal(data.content.title, content, id, null, data)
  }
  window.showAnchorModal = showAnchorModal
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ante-import-tab-bars"] && !Shopify.designMode) return;
  try {
    const tabBarResizeObserver = new ResizeObserver(entries => {
    for (const entry of entries) {
      if (!entry.target.classList.contains("tab-bar")) continue
      if (entry.target.classList.contains("initialised")) {
        entry.target.update()
      }
    }
  })

  function initTabBars() {
    const tabBars = document.querySelectorAll(".tab-bar:not(.initialised)")
    for (const tabBar of tabBars) {
      tabBar.classList.add("initialised")

      const activeIndicator = document.createElement("div")
      activeIndicator.className = "tab-bar-active"
      tabBar.appendChild(activeIndicator)

      const buttons = tabBar.querySelectorAll(".tab-bar-button")
      const contentsWrap = tabBar.nextElementSibling?.classList.contains("tab-contents")
        ? tabBar.nextElementSibling
        : null
      const contents = contentsWrap
        ? Array.from(contentsWrap.querySelectorAll(".tab-content"))
        : []
      let locked = false

      function getParentBox() {
        const parentRect = tabBar.getBoundingClientRect()
        const style = getComputedStyle(tabBar)
        return {
          rect: parentRect,
          left: parentRect.left + parseFloat(style.paddingLeft),
          right: parentRect.right - parseFloat(style.paddingRight),
          top: parentRect.top + parseFloat(style.paddingTop),
          bottom: parentRect.bottom - parseFloat(style.paddingBottom)
        }
      }

      const getCenter = rect => ({
        x: rect.left + rect.width / 2,
        y: rect.top + rect.height / 2
      })

      function updateIndicator() {
        const active = tabBar.querySelector(".tab-bar-button.active")
        if (active) {
          const rect = active.getBoundingClientRect()
          const parentBox = getParentBox()
          activeIndicator.style.left = rect.left - parentBox.rect.left + "px"
          activeIndicator.style.right = parentBox.rect.right - rect.right + "px"
          activeIndicator.style.top = rect.top - parentBox.rect.top + "px"
          activeIndicator.style.bottom = parentBox.rect.bottom - rect.bottom + "px"
        }
      }

      tabBar.update = () => {
        updateIndicator()
      }

      for (const button of buttons) {
        button.addEventListener("mouseenter", () => {
          if (locked) return
          const active = tabBar.querySelector(".tab-bar-button.active")
          if (!active) return

          const parentBox = getParentBox()
          const rect = active.getBoundingClientRect()
          const hoverRect = button.getBoundingClientRect()
          const activeCenter = getCenter(rect)
          const hoverCenter = getCenter(hoverRect)

          if (button === active) {
            const isFirstCol = rect.left <= parentBox.left + 1
            const isLastCol = rect.right >= parentBox.right - 1
            const left = rect.left - parentBox.rect.left - (isFirstCol ? 0 : 5)
            const right = parentBox.rect.right - rect.right - (isLastCol ? 0 : 5)
            activeIndicator.style.left = left + "px"
            activeIndicator.style.right = right + "px"
            activeIndicator.style.top = rect.top - parentBox.rect.top + "px"
            activeIndicator.style.bottom = parentBox.rect.bottom - rect.bottom + "px"
            return
          }

          const isFirstCol = rect.left <= parentBox.left + 1
          const isLastCol = rect.right >= parentBox.right - 1
          const isFirstRow = rect.top <= parentBox.top + 1
          const isLastRow = rect.bottom >= parentBox.bottom - 1

          if (hoverCenter.x < activeCenter.x) {
            const left = rect.left - parentBox.rect.left - (isFirstCol ? 0 : 10)
            activeIndicator.style.left = left + "px"
            activeIndicator.style.right = parentBox.rect.right - rect.right + "px"
          } else if (hoverCenter.x > activeCenter.x) {
            const right = parentBox.rect.right - rect.right - (isLastCol ? 0 : 10)
            activeIndicator.style.left = rect.left - parentBox.rect.left + "px"
            activeIndicator.style.right = right + "px"
          } else {
            activeIndicator.style.left = rect.left - parentBox.rect.left + "px"
            activeIndicator.style.right = parentBox.rect.right - rect.right + "px"
          }

          if (hoverCenter.y < activeCenter.y) {
            const top = rect.top - parentBox.rect.top - (isFirstRow ? 0 : 2)
            activeIndicator.style.top = top + "px"
            activeIndicator.style.bottom = parentBox.rect.bottom - rect.bottom + "px"
          } else if (hoverCenter.y > activeCenter.y) {
            const bottom = parentBox.rect.bottom - rect.bottom - (isLastRow ? 0 : 2)
            activeIndicator.style.top = rect.top - parentBox.rect.top + "px"
            activeIndicator.style.bottom = bottom + "px"
          } else {
            activeIndicator.style.top = rect.top - parentBox.rect.top + "px"
            activeIndicator.style.bottom = parentBox.rect.bottom - rect.bottom + "px"
          }
        })

        button.addEventListener("mouseleave", () => {
          if (!locked) updateIndicator()
        })

        button.addEventListener("click", () => {
          if (locked || button.classList.contains("active")) return
          const currentActive = tabBar.querySelector(".tab-bar-button.active")
          locked = true

          const toRect = button.getBoundingClientRect()
          const fromRect = currentActive.getBoundingClientRect()
          const parentBox = getParentBox()
          const duration = parseFloat(getComputedStyle(activeIndicator).getPropertyValue("--tabs-transition-duration")) * 2000 / 3

          if (contentsWrap) {
            const activeContent = contentsWrap.querySelector(".tab-content.active")
            const border =
              parseFloat(getComputedStyle(contentsWrap).borderTopWidth) +
              parseFloat(getComputedStyle(contentsWrap).borderBottomWidth)

            contentsWrap.style.height = activeContent
              ? activeContent.offsetHeight + border + "px"
              : border + "px"
          }


          if (currentActive) currentActive.classList.remove("active")
          button.classList.add("active")

          if (contentsWrap) {
            const target = button.dataset.tab ?? button.textContent.trim()
            contents.forEach(c => c.classList.toggle("active", c.dataset.tab === target))
            contentsWrap.classList.add("transitioning")
            const activeContent = contentsWrap.querySelector(".tab-content.active")
            const border =
              parseFloat(getComputedStyle(contentsWrap).borderTopWidth) +
              parseFloat(getComputedStyle(contentsWrap).borderBottomWidth)

            contentsWrap.style.height = activeContent
              ? activeContent.offsetHeight + border + "px"
              : border + "px"
          }

          const fromCenter = getCenter(fromRect)
          const toCenter = getCenter(toRect)

          if (toCenter.x < fromCenter.x) {
            activeIndicator.style.left = toRect.left - parentBox.rect.left + "px"
            setTimeout(() => {
              activeIndicator.style.right = parentBox.rect.right - toRect.right + "px"
            }, duration / 2)
          } else {
            activeIndicator.style.right = parentBox.rect.right - toRect.right + "px"
            setTimeout(() => {
              activeIndicator.style.left = toRect.left - parentBox.rect.left + "px"
            }, duration / 2)
          }

          if (toCenter.y < fromCenter.y) {
            activeIndicator.style.top = toRect.top - parentBox.rect.top + "px"
            setTimeout(() => {
              activeIndicator.style.bottom = parentBox.rect.bottom - toRect.bottom + "px"
            }, duration / 2)
          } else {
            activeIndicator.style.bottom = parentBox.rect.bottom - toRect.bottom + "px"
            setTimeout(() => {
              activeIndicator.style.top = toRect.top - parentBox.rect.top + "px"
            }, duration / 2)
          }

          setTimeout(() => {
            locked = false
            if (contentsWrap) contentsWrap.classList.remove("transitioning")
          }, duration)

          tabBar.dispatchEvent(new CustomEvent("tab-changed", {
            detail: button.dataset.tab ?? button.textContent
          }))
        })
      }

      const swipeTargets = [tabBar]
      if (contentsWrap) swipeTargets.push(contentsWrap)

      let swipeStartX = 0
      let swipeStartY = 0

      for (const target of swipeTargets) {
        target.addEventListener("touchstart", e => {
          const t = e.changedTouches[0]
          swipeStartX = t.clientX
          swipeStartY = t.clientY
        })

        target.addEventListener("touchend", e => {
          const t = e.changedTouches[0]
          const dx = t.clientX - swipeStartX
          const dy = t.clientY - swipeStartY

          if (Math.abs(dx) < 50) return
          if (Math.abs(dx) < Math.abs(dy)) return

          const active = tabBar.querySelector(".tab-bar-button.active")
          if (!active) return
          if (locked) return

          const index = Array.from(buttons).indexOf(active)

          if (dx < 0) {
            const next = buttons[index + 1]
            if (next) next.click()
          } else {
            const prev = buttons[index - 1]
            if (prev) prev.click()
          }
        })
      }

      tabBarResizeObserver.observe(tabBar)

      updateIndicator()
    }
  }

  addEventListener("DOMContentLoaded", () => {
    initTabBars()

    document.addEventListener("shopify:section:load", () => {
      initTabBars()
    })
  })
  } catch(e) { console.error(e); }
})();

})();
